import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { ItemCard, ItemIdentity, StatusBadge } from "./ui/ItemCard";
import { ItemStats } from "./ItemStats";
import { formatLabel, getItemDescription, getItemImageUrl, getUserActionNames } from "../utils/itemUtil";
import { seedItemImage } from "../utils/itemImageCache";

// Browse-style result: describes the item and its aggregate actions. The
// signed-in user's own actions are shown separately as "You" badges.
export const ItemResultCard = ({ item, titleComponent = 'h3' }) => {
    const description = getItemDescription(item);
    const mine = getUserActionNames(item);

    // Lets activity cards for the same item reuse this image without a lookup.
    useEffect(() => {
        seedItemImage(item);
    }, [item]);
    return (
        <ItemCard imageUrl={getItemImageUrl(item)} imageAlt={item.name ? `Image for ${item.name}` : ''} mediaResetKey={item.id}>
            <ItemIdentity item={item} titleComponent={titleComponent}>
                {mine.map(a => <StatusBadge key={a}>You · {formatLabel(a)}</StatusBadge>)}
            </ItemIdentity>
            {description ?
                <Typography
                    variant="body2"
                    sx={{ mt: '15px', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflowWrap: 'anywhere' }}
                >
                    {description}
                </Typography>
            : null}
            <Box sx={{ mt: '15px' }}>
                <ItemStats item={item} />
            </Box>
        </ItemCard>
    );
}

export const ItemList2 = ({ items, emptyText = 'No results' }) => {

    if (!items) {
        return <Box></Box>;
    }

    if (items?.length === 0) {
        return (
            <Box sx={{ py: 3 }}>
                <Typography color="text.secondary">{emptyText}</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {items.map((i, ix) => <ItemResultCard key={i.id || ix} item={i} />)}
        </Box>
    );
}
